const translations = {
  title: "Branch Management",
  subtitle: "Setup and govern firm shop locations or production workshop units.",
};

export default translations;
